module.exports = __webpack_public_path__ + "img/logo_cctp.a579c32f.svg";